module.exports = __webpack_public_path__ + "26f55f5b21a0368d5696af2f42069001.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/plus_19.svg
// module id = 1230
// module chunks = 73